import * as yup from 'common/yup';

export const SftpPermissionsNames = {
   READ_FILE: 'READ_FILE',
   WRITE_FILE: 'WRITE_FILE',
   DELETE_FILE: 'DELETE_FILE',
   LIST_FOLDER: 'LIST_FOLDER',
   SHOW_IN_LIST: 'SHOW_IN_LIST',
   CREATE_FOLDER: 'CREATE_FOLDER',
   DELETE_FOLDER: 'DELETE_FOLDER',
} as const;

export const SftpPermissions = yup.object({
   [SftpPermissionsNames.READ_FILE]: yup.boolean(),
   [SftpPermissionsNames.WRITE_FILE]: yup.boolean(),
   [SftpPermissionsNames.DELETE_FILE]: yup.boolean(),
   [SftpPermissionsNames.LIST_FOLDER]: yup.boolean(),
   [SftpPermissionsNames.SHOW_IN_LIST]: yup.boolean(),
   [SftpPermissionsNames.CREATE_FOLDER]: yup.boolean(),
   [SftpPermissionsNames.DELETE_FOLDER]: yup.boolean(),
});
